// Wiederholbare Formularzeilen (Wettbewerber, Prompts). Eine neue Zeile ist
// eine geleerte Kopie der ersten. Was nur zu einer gespeicherten Zeile gehört
// (data-repeat-omit, etwa die Kategorien eines Prompts), fällt dabei weg;
// data-repeat-new erscheint stattdessen.
export default function repeatRows() {
  function clear(item) {
    item.querySelectorAll('[data-repeat-omit]').forEach(function (el) { el.remove(); });
    item.querySelectorAll('[data-repeat-new]').forEach(function (el) { el.hidden = false; });
    item.querySelectorAll('input, textarea').forEach(function (field) { field.value = ''; });
    item.querySelectorAll('select').forEach(function (field) { field.selectedIndex = 0; });
  }

  document.querySelectorAll('[data-repeat-add]').forEach(function (button) {
    button.addEventListener('click', function () {
      const list = document.querySelector(button.dataset.repeatAdd);
      if (!list) return;
      const template = list.querySelector('[data-repeat-item]');
      if (!template) return;

      const clone = template.cloneNode(true);
      clear(clone);
      list.appendChild(clone);
      const first = clone.querySelector('input:not([type=hidden]), textarea');
      if (first) first.focus();
    });
  });

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-repeat-remove]');
    if (!button) return;
    const list = button.closest('[data-repeat-list]');
    const item = button.closest('[data-repeat-item]');
    if (!list || !item) return;
    if (list.querySelectorAll('[data-repeat-item]').length <= 1) {
      clear(item);
      return;
    }
    item.remove();
  });
}
